/**
 * Reading error bodies from the generated hey-api SDKs.
 *
 * A route that declares its error responses produces `{ detail: string }`.
 * FastAPI's own 422 is `{ detail: ValidationError[] }`, and a network failure
 * gives no body at all — so callers get a string only when there genuinely is
 * one, and their own message otherwise.
 */

/** Best available message for a failed SDK call. */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (typeof error !== "object" || error === null) {
    return fallback;
  }
  const detail = (error as { detail?: unknown }).detail;
  return typeof detail === "string" && detail.trim() ? detail : fallback;
}
